import { Button, FormControlLabel, FormGroup, Stack, Switch, TableCell, TableRow, Tooltip } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import PostAddRoundedIcon from "@mui/icons-material/PostAddRounded";
import Swal from "sweetalert2";
import api from "../../../../../Apis";
import { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { useTranslation } from "react-i18next";

export default function RowFanpageItem(props) {
  const { data, stt, index, cookies } = props;
  const { t, i18n } = useTranslation();
  const navigation = useNavigate();
  const [state, setState] = useState({
    loading_delete: false,
    loading_cmt: false,
    loading_inbox: false,
    loading_role: false,
    status_button_recive_cmt: data?.value_status_comment,
    status_button_recive_msg: data?.value_status,
  });
  // const runOrPauseReciveMessage = (data, index, status) => {
  //     props.runOrPauseReciveMessage(data, index, status)
  // }

  const runOrPauseReciveMessage = (data, index, status) => {
    Swal.fire({
      title: t("common.alert.confirmationQuestion"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common.alert.confirm"),
      cancelButtonText: t("common.alert.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setState({ ...state, loading_inbox: true });
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + cookies.is_login,
          },
          body: JSON.stringify({
            fanpage_id: data.fanpage_id,
            status: status,
            lang: i18n.language,
          }),
        };
        fetch(api.run_and_pause_recive_message, requestOptions)
          .then((res) => res.json())
          .then((result) => {
            if (result.success) {
              setState({
                ...state,
                loading_inbox: false,
                status_button_recive_msg: status,
              });
              Swal.fire(result.message, "", "success");
            } else {
              setState({ ...state, loading_inbox: false });
              Swal.fire(result.message, "", "error");
            }
          });
      }
    });
  };
  const runOrPauseReciveComment = (data, index, status) => {
    Swal.fire({
      title: t("common.alert.confirmationQuestion"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common.alert.confirm"),
      cancelButtonText: t("common.alert.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setState({
          ...state,
          loading_cmt: true,
        });
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + cookies.is_login,
          },
          body: JSON.stringify({
            fanpage_id: data.fanpage_id,
            status: status,
            lang: i18n.language,
          }),
        };
        fetch(api.run_and_pause_recive_comment, requestOptions)
          .then((res) => res.json())
          .then((result) => {
            if (result.success) {
              // const copy_fanpage_actives = [...state.fanpage_actives];
              // copy_fanpage_actives[index].value_status_comment = status;
              // setState({
              //     ...state,
              //     fanpage_actives: copy_fanpage_actives
              // })
              setState({
                ...state,
                loading_cmt: false,
                status_button_recive_cmt: status,
              });
              Swal.fire(result.message, "", "success");
            } else {
              setState({
                ...state,
                loading_cmt: false,
              });
              Swal.fire(result.message, "", "error");
            }
          });
      }
    });
  };

  const remove = (data, index) => {
    Swal.fire({
      title: t("common.alert.confirmationQuestion"),
      text: t("dashboard.dataDeletionWarning"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("common.alert.confirm"),
      cancelButtonText: t("common.alert.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setState({
          ...state,
          loading_delete: true,
        });
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + cookies.is_login,
          },
          body: JSON.stringify({
            fanpage_id: data.fanpage_id,
            lang: i18n.language,
          }),
        };
        fetch(api.remove, requestOptions)
          .then((res) => res.json())
          .then((result) => {
            if (result.success) {
              props.remove(index);
              Swal.fire({
                // title: result.message,
                title: t("common.alert.deleteSuccess"),
                icon: "success",
                timer: 1500,
              });
              setState({
                ...state,
                loading_delete: false,
              });
            } else {
              setState({
                ...state,
                loading_delete: false,
              });
              Swal.fire({
                title: result.message,
                icon: "error",
                timer: 1500,
              });
            }
          });
      }
    });
  };

  const refreshRole = (data) => {
    setState({ ...state, loading_role: true });
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + cookies.is_login,
      },
      body: JSON.stringify({
        fanpage_id: data.fanpage_id,
        lang: i18n.language,
      }),
    };
    fetch(api.refresh_role, requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          Swal.fire({
            title: result.message,
            icon: "success",
          });
          setState({
            ...state,
            loading_role: false,
          });
        } else {
          setState({
            ...state,
            loading_role: false,
          });
          Swal.fire({
            title: result.message,
            icon: "error",
          });
        }
      });
  };

  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell>{stt}</TableCell>
      <TableCell>
        <a
          href={`https://www.facebook.com/${data.fanpage_id}`}
          target="_blank"
          rel="noreferrer"
        >
          {data.fanpage_id}
        </a>
      </TableCell>
      <TableCell>
        <b>{data.fanpage_name}</b>
      </TableCell>

      <TableCell align="left">
        <Stack direction="column" spacing={0} alignItems="flex-start">
          <Link
            to={"/dashboard/split-group"}
            style={{
              fontWeight: 500,
              color: "#333",
            }}
          >
            {t("dashboard.table.action.post")}
          </Link>
          <Link
            to={`/dashboard/${props.data.fanpage_id}/chatbot`}
            style={{
              fontWeight: 500,
              color: "#333",
              marginTop: 8,
            }}
          >
            Kịch bản Chatbot
          </Link>
          <Link
            to={data.fanpage_id + "/customer"}
            style={{
              fontWeight: 500,
              color: "#333",
              marginTop: 8,
            }}
          >
            {t("dashboard.table.action.customers")}
          </Link>

          <FormGroup>
            <FormControlLabel control={<Switch checked={!!state.status_button_recive_msg} color={state.status_button_recive_msg ? "warning" : "default"} />} label={state.status_button_recive_msg
              ? t("dashboard.table.action.disableInbox")
              : t("dashboard.table.action.enableInbox")} 
            onClick={() => 
              runOrPauseReciveMessage(
                data,
                index,
                !state.status_button_recive_msg
              )}
              disabled={state.loading_inbox}
            /> 
            <FormControlLabel control={<Switch checked={!!state.status_button_recive_cmt} color={state.status_button_recive_cmt ? "secondary" : "default"} />} label={state.status_button_recive_cmt
              ? t("dashboard.table.action.disableComment")
              : t("dashboard.table.action.enableComment")} 
            onClick={() => 
              runOrPauseReciveComment(
                data,
                index,
                !state.status_button_recive_cmt
              )}
              disabled={state.loading_cmt}
            /> 
          </FormGroup>

          <LoadingButton
            loading={state.loading_role}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              mt: 1,
              width: 160,
            }}
            onClick={() => refreshRole(data)}
            variant="contained"
          >
            {t("dashboard.table.action.refresh_role")}
          </LoadingButton>
          
         
          {/* <LoadingButton
            loading={state.loading_inbox}
            sx={{ textTransform: "none", fontWeight: 500, mt: 1, width: 160, }}
            color={state.status_button_recive_msg ? "warning" : "inherit"}
            onClick={() =>
              runOrPauseReciveMessage(
                data,
                index,
                !state.status_button_recive_msg
              )
            }
            variant="contained"
          >
            {state.status_button_recive_msg
              ? t("dashboard.table.action.disableInbox")
              : t("dashboard.table.action.enableInbox")}
          </LoadingButton> */}

          {/* <LoadingButton
            loading={state.loading_cmt}
            sx={{ textTransform: "none", fontWeight: 500, mt: 1, width: 160, }}
            color={state.status_button_recive_cmt ? "secondary" : "inherit"}
            onClick={() =>
              runOrPauseReciveComment(
                data,
                index,
                !state.status_button_recive_cmt
              )
            }
            variant="contained"
          >
            {state.status_button_recive_cmt
              ? t("dashboard.table.action.disableComment")
              : t("dashboard.table.action.enableComment")}
          </LoadingButton> */}

          <LoadingButton
            loading={state.loading_delete}
            sx={{ textTransform: "none", fontWeight: 500, mt: 1, width: 160, }}
            color="error"
            onClick={() => remove(data, index)}
            variant="contained"
          >
            {t("common.delete")}
          </LoadingButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
